import { LoadingOutlined_str } from '@zenlayer/zen-design-icons';
import { useControllableValue } from 'ahooks';
import classNames from 'classnames';
import React from 'react';
import insertRipple from '../_util/insertRipple';
import { pickDomAttrs } from '../_util/utils';
import { useConfig } from '../hooks/useConfig';
import SvgIcon from '../svg-icon';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Switch = props => {
  const {
    disabled,
    loading,
    size = 'm',
    checkedChildren,
    unCheckedChildren,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const {
    locale: {
      Switch: SwitchLocale
    }
  } = useConfig();
  const baseClassName = "".concat(prefixClass, "-switch");
  const attrs = pickDomAttrs(restProps);
  const [checked, onChange] = useControllableValue(props, {
    defaultValue: false,
    defaultValuePropName: 'defaultChecked',
    valuePropName: 'checked',
    trigger: 'onChange'
  });
  const canDoSomething = !disabled && !loading;
  return /*#__PURE__*/_jsxs("button", {
    ...attrs.data,
    ref: ref => {
      insertRipple({
        className: "".concat(prefixClass, "-ripple"),
        ref
      });
    },
    type: "button",
    onClick: () => {
      canDoSomething && onChange(!checked);
    },
    className: classNames(className, baseClassName, {
      ["".concat(baseClassName, "-").concat(size)]: !!size,
      ["".concat(baseClassName, "-checked")]: checked,
      ["".concat(baseClassName, "-disabled")]: !!disabled,
      ["".concat(baseClassName, "-loading")]: !!loading
    }),
    style: style,
    children: [checked && /*#__PURE__*/_jsx("div", {
      className: "checkedChildren",
      children: checkedChildren !== null && checkedChildren !== void 0 ? checkedChildren : SwitchLocale.on
    }), !checked && /*#__PURE__*/_jsx("div", {
      className: "unCheckedChildren",
      children: unCheckedChildren !== null && unCheckedChildren !== void 0 ? unCheckedChildren : SwitchLocale.off
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-handle"),
      children: loading && /*#__PURE__*/_jsx(SvgIcon, {
        spin: true,
        svgStr: LoadingOutlined_str,
        className: "loadingIcon"
      })
    })]
  });
};
export default Switch;